import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import useScrollReveal from '../hooks/useScrollReveal';

// Font Awesome icons
import { FaReact, FaNodeJs } from "react-icons/fa";
import { FaFlutter } from "react-icons/fa6";

// Material Design icons
import { MdOutlineSecurity, MdArchitecture, MdDesignServices } from "react-icons/md";

const services = [
  {
    id: 0,
    icon: <FaReact />,
    title: "Frontend Development",
    description: "Building responsive, accessible user interfaces with React. We focus on performance optimization, state management, and seamless user experiences.",
    tags: ["React", "Next.js", "TypeScript"],
    details: [
      "Custom React component development",
      "Performance optimization and lazy loading",
      "Accessibility (a11y) compliance",
      "State management with Redux/Context API",
      "Server-side rendering (SSR) with Next.js"
    ]
  },
  {
    id: 1,
    icon: <FaNodeJs />,
    title: "Backend Development",
    description: "Scalable server-side solutions with Node.js and Python. We implement RESTful APIs, GraphQL, and microservices architectures for your business logic.",
    tags: ["Node.js", "Python", "PostgreSQL"],
    details: [
      "API development (REST & GraphQL)",
      "Database design and optimization",
      "Authentication and authorization",
      "Microservices architecture",
      "Websocket and real-time communication"
    ]
  },
  {
    id: 2,
    icon: <FaFlutter />,
    title: "Mobile Development",
    description: "Cross-platform mobile applications with React Native. We deliver native-like performance with shared codebase for iOS and Android.",
    tags: ["Flutter", "Dart", "Firebase"],
    details: [
      "Cross-platform mobile apps",
      "Native module integration",
      "Offline-first capabilities",
      "Push notifications",
      "App store deployment"
    ]
  },
  {
    id: 3,
    icon: <MdOutlineSecurity />,
    title: "DevOps & Security",
    description: "Secure deployment pipelines and infrastructure management. We implement CI/CD, monitoring, and security best practices for your applications.",
    tags: ["Docker", "AWS", "Security"],
    details: [
      "CI/CD pipeline setup",
      "Containerization with Docker",
      "Cloud infrastructure (AWS/GCP)",
      "Security audits and penetration testing",
      "Monitoring and logging"
    ]
  },
  {
    id: 4,
    icon: <MdArchitecture />,
    title: "Technical Consulting",
    description: "Expert guidance on architecture, technology selection, and development processes to ensure your project's success.",
    tags: ["Architecture", "Code Review", "Mentoring"],
    details: [
      "System architecture design",
      "Technology stack selection",
      "Code reviews and audits",
      "Team mentoring and training",
      "Project rescue"
    ]
  },
  {
    id: 5,
    icon: <MdDesignServices />,
    title: "UI/UX Design",
    description: "User-centered design solutions that combine aesthetics with functionality to create engaging digital experiences.",
    tags: ["Figma", "Prototyping", "User Testing"],
    details: [
      "User research and personas",
      "Wireframing and prototyping",
      "UI design systems",
      "User testing and iteration",
      "Design-to-development handoff"
    ]
  }
];

const ServicesPage = ({ showToast }) => {
  useScrollReveal();

  useEffect(() => {
    // Scroll to top on page load or refresh
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="services-page">
      <section className="featured-section">
        <div className="page-title in-view">
          <h2>Our Services</h2>
          <p className="page-subtitle">Comprehensive solutions for your digital needs</p>
        </div>
        <div className="services__grid">
          {services.map((service) => (
            <div className="service-card fade-in" key={service.id}>
              <div className="service-card__icon">{service.icon}</div>
              <h3 className="service-card__title">{service.title}</h3>
              <p className="service-card__description">{service.description}</p>
              <div className="project-card__tech">
                {service.tags.map(tag => (
                  <span className="tech-tag" key={tag}>{tag}</span>
                ))}
              </div>
              <div>
                <br />
              </div>
              <Link to={`/services/${service.id}`} className="button button--small">Learn More</Link>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default ServicesPage;